import { render } from "./sign-in.vue?vue&type=template&id=2473b4b4&scoped=true"
import script from "./sign-in.vue?vue&type=script&lang=js"
export * from "./sign-in.vue?vue&type=script&lang=js"

import "./sign-in.vue?vue&type=style&index=0&id=2473b4b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2473b4b4"]])

export default __exports__